/**
 * Constantes relacionadas à autenticação
 */
export const AUTH_CONSTANTS = {
    ERRORS: {
        EMAIL_NOT_VALIDATED: 'email_not_validated',
        AUTHENTICATION_FAILED: 'authentication_failed',
        SESSION_EXPIRED: 'session_expired',
    },
    TOKEN: {
        SECONDS_PER_MINUTE: 60,
        DEFAULT_REFRESH_THRESHOLD_MINUTES: 5,
    },
    STORAGE_KEYS: {
        AUTH_TOKEN: 'auth_token',
        REFRESH_TOKEN: 'refresh_token',
        USER_ID: 'user_id',
        CANDIDATE_ID: 'candidate_id',
        MANAGER_ID: 'manager_id',
        COMPANY_ID: 'company_id',
        EM_UNIT_ID: 'em_unit_id',
        LEGACY_PASSWORD_LOGIN: 'legacy_password_login',
        REMEMBER_ME: 'remember_me',
    },
    SESSION_STORAGE: {
        REDIRECT_FROM_OFFERS: 'redirect_from_offers',
    },
    RATE_LIMIT: {
        RESEND_EMAIL_MS: 60000, // 1 minuto
    },
} as const;

